import { useIntl } from 'react-intl';

import NewPageBtn from 'components/Pages/components/NewPageBtn/NewPageBtn';

import './EmptyState.less';

const EmptyState = ({ permissions }) => {
  const { formatMessage } = useIntl();

  const { HIDE_CREATE_PAGE } = permissions;

  const contents = [
    {
      title: formatMessage({
        id: 'pages.empty_state.content.ready_to_use.title'
      }),
      subtitle: formatMessage({
        id: 'pages.empty_state.content.ready_to_use.subtitle'
      })
    },
    {
      title: formatMessage({
        id: 'pages.empty_state.content.create_custom_pages.title'
      }),
      subtitle: formatMessage({
        id: 'pages.empty_state.content.create_custom_pages.subtitle'
      })
    },
    {
      title: formatMessage({
        id: 'pages.empty_state.content.rank_in_search_engine.title'
      }),
      subtitle: formatMessage({
        id: 'pages.empty_state.content.rank_in_search_engine.subtitle'
      })
    }
  ];

  return (
    <div className="br-pages-empty-state">
      <div className="br-pages-empty-state__container">
        <div>
          <span className="br-pages-empty-state__title">
            {formatMessage({ id: 'pages.empty_state.title' })}
          </span>
          <div className="br-pages-empty-state__content">
            {contents.map(({ title, subtitle }, index) => (
              <div key={index} className="br-pages-empty-state__content__item">
                <span className="br-pages-empty-state__content__item_title">
                  {title}
                </span>
                <span className="br-pages-empty-state__content__item_subtitle">
                  {subtitle}
                </span>
              </div>
            ))}
          </div>
          {!HIDE_CREATE_PAGE && <NewPageBtn />}
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
